<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('exercises')">Ejercicio </inertia-link>
      <span class="text-white font-medium">/   {{ form.name}}
      </span>
    </h1>
    <trashed-message v-if="exercise.status==0" class="mb-6" @restore="restore">
     Ejercicio  Eliminado!
    </trashed-message>
      <inertia-link  class="px-6 py-2 btn-indigoOrange" :href="route('exercisesR.edit', exercise.id)">
        <span>Repeticiones</span>
      </inertia-link>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-4/6" label="Nombre" required/>
          <select-input v-model="form.status" :error="form.errors.status" class="pr-6 pb-8 w-full lg:w-2/6" label="Activo">
            <option value="1">SI</option>
            <option value="0">NO</option>
          </select-input>
          <div class="pr-6 pb-8 w-full lg:w-6/6">
           <label style="color: white; font-weight: 700;" class="form-label" >Nivel:</label>
            <VueMultiselectComponent
              class="form-input bg-inexinput text-inexorange  border-inexgray focus:border-inexorange w-full"
              v-model="form.nivel_id"
              :options="niveless"
            />
          </div>
         
          <text-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full lg:w-6/6" label="Descripción"/>
          <text-input v-model="form.videoUrl" :error="form.errors.videoUrl" class="pr-6 pb-8 w-full lg:w-6/6" label="Url Video Google Drive"/>

       </div>
        <div class="px-8 py-4 bg-transparent flex justify-between items-center">
          <button v-if="exercise.status==1" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar</button>          
          <loading-button :loading="form.processing" style="color: white" class="px-8 py-4 btn-indigoOrange" type="submit">Actualizar</loading-button>
        </div>
      </form>
    </div>
    <br><br><br>
    <iframe :src="form.videoUrl" width="400" height="280" allow="autoplay"></iframe>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VueMultiselectComponent from 'vue-multiselect-component'
import FileInput from '@/Shared/FileInput'


export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    FileInput,
    TrashedMessage,
    vSelect,
    VueMultiselectComponent
  },
  layout: Layout,
  props: {
    exercise: Object,
    niveles: Array,
    nives: Array,
  },
  remember: 'form',
  data() {
    return {
      niveless: this.niveles,
      form: this.$inertia.form({
        name: this.exercise.name,
        videoUrl: this.exercise.videoUrl,
        description: this.exercise.description,
        status: this.exercise.status,
        nivel_id: this.nives,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('exercises.update', this.exercise.id))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('exercises.destroy', this.exercise.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('exercises.restore', this.exercise.id))
      }
    },
  },
}
</script>
